import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getIsKioskVersion } from '@yme/selectors/common';
export const KIOSK_HOME_URL = 'kioskHomeUrl';
export const KIOSK_URL_PATH = 'kiosk-landing';
export const useKioskHomeUrl = (originUrl) => {
    const isKioskVersion = useSelector(getIsKioskVersion);
    const [homeUrl, setHomeUrl] = useState(() => localStorage.getItem(KIOSK_HOME_URL) || '');
    useEffect(() => {
        const currentPathName = window.location.pathname;
        if (currentPathName.includes(KIOSK_URL_PATH) && !localStorage.getItem(KIOSK_HOME_URL)) {
            localStorage.setItem(KIOSK_HOME_URL, currentPathName);
            setHomeUrl(currentPathName);
        }
    }, []);
    return isKioskVersion ? homeUrl : originUrl;
};
